import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Navbar = () => {
  const { language, changeLanguage, t } = useLanguage();
  const [isLangOpen, setIsLangOpen] = useState(false);

  const languages = [
    { code: 'fi', label: 'FI', flag: '🇫🇮' },
    { code: 'en', label: 'EN', flag: '🇬🇧' },
    { code: 'sv', label: 'SV', flag: '🇸🇪' }
  ];

  const currentLang = languages.find(lang => lang.code === language);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-md border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img 
              src="/milazzo-logo.svg" 
              alt="Milazzo Pizza" 
              className="h-12 w-auto transform group-hover:scale-110 transition-transform duration-300"
            />
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className="text-white text-sm font-medium tracking-wider hover:text-red-500 transition-colors duration-300"
            >
              {t('home')}
            </Link>
            <Link
              to="/#about"
              className="text-white text-sm font-medium tracking-wider hover:text-red-500 transition-colors duration-300"
            >
              {t('about')}
            </Link>
            <Link
              to="/#contact"
              className="text-white text-sm font-medium tracking-wider hover:text-red-500 transition-colors duration-300"
            >
              {t('contact')}
            </Link>
          </div>

          {/* CTA and Language Selector */}
          <div className="flex items-center gap-4">
            {/* Order Now Button */}
            <a
              href="https://order.site/milazzo"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2 bg-red-600 text-white text-sm font-medium tracking-wider border border-red-600 hover:bg-red-700 hover:border-red-700 transition-all duration-300"
            >
              {t('orderNow')}
            </a>

            {/* Language Selector */}
            <div className="relative">
              <button
                onClick={() => setIsLangOpen(!isLangOpen)}
                className="flex items-center gap-2 px-3 py-2 text-white text-sm hover:text-red-500 transition-colors duration-300"
              >
                <Globe className="w-4 h-4" />
                <span className="font-medium">{currentLang?.label}</span>
                <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${isLangOpen ? 'rotate-180' : ''}`} />
              </button>

              {isLangOpen && (
                <div className="absolute top-full right-0 mt-2 bg-black/95 border border-white/10 rounded-lg overflow-hidden shadow-xl min-w-[120px]">
                  {languages.map((lang) => (
                    <button
                      key={lang.code}
                      onClick={() => {
                        changeLanguage(lang.code);
                        setIsLangOpen(false);
                      }}
                      className={`w-full px-4 py-2 text-left text-sm flex items-center gap-2 hover:bg-red-600/20 transition-colors duration-200 ${
                        language === lang.code ? 'bg-red-600/30 text-red-500' : 'text-white'
                      }`}
                    >
                      <span>{lang.flag}</span>
                      <span>{lang.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;